// packages/core/src/diff/index.ts
import type { ResolvedModel } from "../resolver.js";
import type { ChangeSet } from "../diff-types.js";
import { diffModulesTopLevel } from "./modules.js";
import { diffProcesses } from "./processes.js";
import { diffSubprocesses } from "./subprocesses.js";
import { diffViews } from "./views.js";

export { buildLookup } from "./lookup.js";
export { moduleNameIndex, pathStableKey } from "./processes.js";
export {
  diffEdges,
  edgeIdentityKey,
  edgeAnchorKey,
  edgeEndpointKeys,
  type EdgeDiff,
} from "./edges.js";
export {
  diffAspectGraphs,
  diffModelAspects,
  type AspectGraphDiff,
  type AspectGroupDiff,
  type AspectRename,
} from "./aspects.js";

export function diffModels(before: ResolvedModel, after: ResolvedModel): ChangeSet {
  return {
    modules: diffModulesTopLevel(before.modules, after.modules),
    processes: diffProcesses(before, after),
    subprocesses: diffSubprocesses(before, after),
    views: diffViews(before.views, after.views),
  };
}
